import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Breadcrumb, Card, Form } from 'react-bootstrap';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import { Button } from 'primereact/button';
import '../../assets/css/calender.css';
import axios from 'axios';
import config from '../../config';
import CustomToast from '../../components/CustomToast';
import { useAuth } from '../../context/AuthContext';
import CustomConfirmPopup from "../../components/CustomConfirmPopup";

const Add_services = () => {
    const { accessToken } = useAuth();
    const [services, setServices] = useState([]);
    const [serviceData, setServiceData] = useState({
        description: '',
        Remarks: '',
        sac_code: '',
        hsn: '',
        price: 0
    });
    const [editingService, setEditingService] = useState(null);
    const toastRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [formSearchTerm, setFormSearchTerm] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };

    const handleCancelEdit = () => {
        setEditingService(null);
        setServiceData({
            description: '',
            Remarks: '',
            sac_code: '',
            hsn: '',
            price: 0
        });
        setFormSearchTerm(''); // Optionally reset form-triggered search
    };




    // Fetch services on component mount
    useEffect(() => {
        fetchServices();
    }, []);
    // Fetch all services
    const fetchServices = async (term = '') => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/Service_Routes/fetchallservices`, {
                headers: { Authorization: `Bearer ${accessToken}` },
                params: { search: term }
            });
            setServices(response.data.data);
        } catch (error) {
            console.error("Error fetching services:", error);
        }
    };


    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            // If not editing, combine the search bar and form description
            if (!editingService) {
                const term = searchTerm || formSearchTerm;
                setDebouncedSearch(term);
            } else {
                setDebouncedSearch(searchTerm); // Only search bar is respected
            }
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchTerm, formSearchTerm, editingService]);

    useEffect(() => {
        fetchServices(debouncedSearch);
    }, [debouncedSearch]);


    // Handle form submission for adding or updating a service
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingService) {
                // Edit service
                await axios.put(`${config.apiBASEURL}/Service_Routes/editServices/${editingService.Services_Table_id}`, serviceData, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });
                showMessage('success', 'Service updated successfully');
            } else {
                // Add service
                await axios.post(`${config.apiBASEURL}/Service_Routes/addServices`, serviceData, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                });
                showMessage('success', 'Service added successfully');
            }
            setServiceData({ description: '', Remarks: '', sac_code: '', hsn: '', price: '' });
            setEditingService(null);
            fetchServices();
        } catch (error) {
            console.error("Error saving service:", error);
            showMessage('error', 'Failed to save service');
        }
    };

    // Edit service
    const handleEdit = (service) => {
        setEditingService(service);
        setServiceData({
            description: service.description,
            Remarks: service.Remarks,
            sac_code: service.sac_code,
            hsn: service.hsn,
            price: service.price
        });
    };

    // Delete service
    const handleDelete = async (id) => {
        try {
            await axios.delete(`${config.apiBASEURL}/Service_Routes/deleteServices/${id}`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            showMessage('success', 'Service deleted successfully');
            fetchServices();
        } catch (error) {
            console.error("Error deleting service:", error);
        }
    };

    return (
        <>
            <Row className='body_content'>
                <Row className='mx-0'>
                    <Col md={6} lg={9} className='mb-4'>
                        <Breadcrumb>
                            <Breadcrumb.Item active>Services</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Row className="servicePage">
                        <Col lg='4' md='12' className="pe-lg-3 ps-0">
                            <Card className="h-auto sticky-top">
                                <Card.Header><b>{editingService ? 'Edit Service' : 'Add Service'}</b></Card.Header>
                                <Card.Body>
                                    <Form onSubmit={handleSubmit}>
                                        <Col lg='12' className='mb-4'>
                                            <Card className='addEm shadow-0 p-0'>
                                                <Card.Body className='p-0'>
                                                    <Row className="mb-3">
                                                        <Col lg={12} md={12}>
                                                            <Form.Label>Description <span className='text-danger'>*</span></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Enter Service Description"
                                                                value={serviceData.description}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    setServiceData({ ...serviceData, description: value });

                                                                    // Only trigger search if not editing
                                                                    if (!editingService) {
                                                                        setFormSearchTerm(value);
                                                                    }
                                                                }}
                                                                required
                                                            />
                                                        </Col>
                                                        <Col lg={12} md={12}>
                                                            <Form.Label>Remarks</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Remarks"
                                                                value={serviceData.Remarks}
                                                                onChange={(e) => setServiceData({ ...serviceData, Remarks: e.target.value })}
                                                            />
                                                        </Col>
                                                        <Col lg={6} md={6}>
                                                            <Form.Label>SAC Code</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="SAC Code"
                                                                value={serviceData.sac_code}
                                                                onChange={(e) => setServiceData({ ...serviceData, sac_code: e.target.value })}
                                                            />
                                                        </Col>
                                                        <Col lg={6} md={6}>
                                                            <Form.Label>HSN</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="HSN Code"
                                                                value={serviceData.hsn}
                                                                onChange={(e) => setServiceData({ ...serviceData, hsn: e.target.value })}
                                                            />
                                                        </Col>
                                                        <Col lg={12} md={12}>
                                                            <Form.Label>Price</Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                placeholder="Price"
                                                                value={serviceData.price}
                                                                onChange={(e) => setServiceData({ ...serviceData, price: e.target.value })}
                                                                required
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col lg='12' className='d-flex justify-content-end'>
                                            <Button
                                                className='py-2 border-0 me-2'
                                                label={editingService ? 'Update' : 'Save'}
                                                icon={editingService ? 'pi pi-pencil' : 'pi pi-plus'}
                                                type="submit"
                                                severity="help"
                                            />
                                            {editingService && (
                                                <Button
                                                    className='py-2 border-0'
                                                    label="Cancel"
                                                    icon="pi pi-times"
                                                    type="button"
                                                    severity="secondary"
                                                    onClick={handleCancelEdit}
                                                />
                                            )}

                                        </Col>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg='8' md='12'>
                            <Form.Group className="mb-3 text-start">
                                <Form.Label><strong>Search Services</strong></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Search by Description, SAC, HSN, Price..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />

                            </Form.Group>

                            <Card className='text-center h-auto resp_report'>
                                <MDBTable responsive striped hover small>
                                    <MDBTableHead light>
                                        <tr>
                                            <th>#</th>
                                            <th>Description</th>
                                            <th>Remarks</th>
                                            <th>SAC Code</th>
                                            <th>HSN</th>
                                            <th>Price</th>
                                            <th>Action</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        {services.map((service, index) => (
                                            <tr key={service.Services_Table_id}>
                                                <td>{index + 1}</td>
                                                <td>{service.description}</td>
                                                <td>{service.Remarks || 'N/A'}</td>
                                                <td>{service.sac_code || 'N/A'}</td>
                                                <td>{service.hsn || 'N/A'}</td>
                                                <td>{service.price}</td>
                                                <td>
                                                    <Button
                                                        icon="pi pi-pencil"
                                                        className="p-button-sm p-button-text p-button-primary"
                                                        onClick={() => handleEdit(service)}
                                                    />


                                                    <CustomConfirmPopup
                                                        message="Are you sure you want to Delete this Service?"
                                                        icon="pi pi-exclamation-triangle"
                                                        defaultFocus="accept"
                                                        acceptClassName="p-button-danger"
                                                        buttonLabel="Delete"
                                                        title="Delete Service"
                                                        buttonClass="p-button-warning p-button-text"
                                                        className="border-0 p-0"
                                                        buttonIcon="pi pi-trash"
                                                        onConfirm={() => handleDelete(service.Services_Table_id)}
                                                        onReject={() => console.log('Delete action canceled')}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </MDBTableBody>
                                </MDBTable>
                            </Card>
                        </Col>
                        <CustomToast ref={toastRef} />
                    </Row>
                </Row>
            </Row>
        </>
    );
};

export default Add_services;